import { render, staticRenderFns } from "./custom-notifications.vue?vue&type=template&id=5b291f8e&scoped=true&"
import script from "./custom-notifications.ts?vue&type=script&lang=ts&"
export * from "./custom-notifications.ts?vue&type=script&lang=ts&"
import style0 from "./custom-notifications.scss?vue&type=style&index=0&id=5b291f8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b291f8e",
  null
  
)

export default component.exports